import TopBar from '../home/components/TopBar';
import Header from '../home/components/Header';
import ContactSection from '../home/components/ContactSection';
import FAQSection from '../home/components/FAQSection';
import Footer from '../home/components/Footer';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';
import ChatPopup from '../home/components/ChatPopup';

const Contato = () => {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <div className="py-16">
        <ContactSection />
        <FAQSection />
      </div>

      <Footer />
      <FloatingWhatsApp />
      <ChatPopup />
    </div>
  );
};

export default Contato;
